<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    
    xml:space="preserve"
  >
    <g>
      <g id="stop">
        <rect :fill="fill" width="100%" height="100%" />
      </g>
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "line_",
  mixins: [MixinStates],
  props: {
    fill: {
      type: String,
      default: "black",
    },
  },
};
</script>
